import styled from 'styled-components'

export const QuestionEditHeaderUi = styled.div`
  font-size: 20px;
  color: #797f89;
  margin-bottom: 15px;
  text-align: center;
  text-transform: uppercase;
`
